/*
 * TC 카드 퀵애드 — AJAX 담기 + 드로어 (테마 이벤트 연동)
 * .tc-p-quick-btn[data-quick-add] 클릭 → /cart/add.js → CartAddEvent 디스패치
 * → 드로어 자동 열림(auto-open) + 카트 섹션 재렌더 + 헤더 카운트 갱신.
 */
import { CartAddEvent } from '@theme/events';

async function quickAdd(btn) {
  const id = btn.dataset.variantId;
  if (!id || btn.dataset.adding === '1') return;
  btn.dataset.adding = '1';
  btn.setAttribute('aria-busy', 'true');

  // 드로어/카트 섹션 재렌더용 섹션 ID 수집
  const sectionIds = [];
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((c) => {
    const sid = c.dataset.sectionId;
    if (sid && sectionIds.indexOf(sid) === -1) sectionIds.push(sid);
  });

  const body = { items: [{ id: id, quantity: 1 }] };
  if (sectionIds.length) body.sections = sectionIds.join(',');

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error('cart add failed');
    const data = await res.json();

    // 드로어를 최대한 빨리 열기 위해 즉시 디스패치.
    // (헤더 카운트는 cart:update 리스너가 /cart.js로 갱신)
    document.dispatchEvent(
      new CartAddEvent(undefined, 'tc-quick-add', {
        source: 'tc-quick-add',
        productId: btn.dataset.productId,
        sections: data.sections,
      })
    );
  } catch (err) {
    console.error(err);
  } finally {
    btn.dataset.adding = '';
    btn.removeAttribute('aria-busy');
  }
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.tc-p-quick-btn[data-quick-add]');
  if (!btn) return;
  e.preventDefault();
  quickAdd(btn);
});
